var map = {
	"./complete_da.mp3": "c1a9",
	"./complete_en.mp3": "7ea2",
	"./complete_ru.mp3": "c785",
	"./step_1_da.mp3": "d916",
	"./step_1_en.mp3": "ffb5",
	"./step_1_ru.mp3": "9f52",
	"./step_2_da.mp3": "02ad",
	"./step_2_en.mp3": "2cb1",
	"./step_2_ru.mp3": "683f",
	"./step_3_da.mp3": "11a5",
	"./step_3_en.mp3": "1c24",
	"./step_3_ru.mp3": "2fef",
	"./step_4_da.mp3": "b75b",
	"./step_4_en.mp3": "f5e2",
	"./step_4_ru.mp3": "236c",
	"./step_5_da.mp3": "d44c",
	"./step_5_en.mp3": "656c",
	"./step_5_ru.mp3": "cff3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4dbf";